import { GapFillerSettingsView } from '@elva/ui';
import { useNavigate } from 'react-router-dom';

/**
 * Settings · AI Brain › Gap Filler (amendment 26 §4). Every button goes
 * somewhere: Add a rule and Edit open the rule page, Edit messages opens the
 * offer editor, and the card-05 fixes focus a rule's minimum or switch a rule on.
 */
export function SettingsGapFillerPage() {
  const navigate = useNavigate();
  return (
    <GapFillerSettingsView
      onAddRule={() => { void navigate('/settings/ai/gap-filler/rules/new'); }}
      onEditRule={(id) => { void navigate(`/settings/ai/gap-filler/rules/${id}`); }}
      onEditOffer={() => { void navigate('/settings/ai/gap-filler/offer/messages'); }}
      onShortenRule={(id) => { void navigate(`/settings/ai/gap-filler/rules/${id}?focus=shortest-gap`); }}
    />
  );
}
